import { useSurveyMetadataReadiness } from 'src/hooks/analytics/useSurveyMetadataReadiness.hook';
import { SubscriptionContext } from './Subscription.context';
import useSubscription from './Subscription.hook';
import { tSubscriptionProviderProps } from './Subscription.types';

export default function SubscriptionProvider(
  props: tSubscriptionProviderProps,
) {
  const { children } = props;
  const subscription = useSubscription();
  useSurveyMetadataReadiness(subscription);
  return (
    <SubscriptionContext.Provider value={subscription}>
      {children}
    </SubscriptionContext.Provider>
  );
}
